module.exports = __webpack_public_path__ + "img/cog.04e82818.png";